// 📄 pages/Proyectos/components/TareasProximasVencerBanner.tsx
// Alerta "al entrar al proyecto" — a diferencia de
// AusenciasProximaSemanaBanner.tsx (todo el equipo), esto es PERSONAL: solo
// avisa de las tareas asignadas al usuario actual que vencen pronto, que es
// lo realmente accionable para quien está mirando.
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext.tsx';
import { getTareas, Tarea, estaVencida, venceEnProximaSemana } from '../../../services/tareaService.ts';

interface TareasProximasVencerBannerProps {
  projectId: string;
}

export default function TareasProximasVencerBanner({ projectId }: TareasProximasVencerBannerProps) {
  const { user } = useAuth();
  const [tareas, setTareas] = useState<Tarea[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!projectId || !user) { setLoading(false); return; }
    getTareas(projectId)
      .then((lista) => setTareas(lista.filter((t) => t.asignadoA === user.uid && (estaVencida(t) || venceEnProximaSemana(t)))))
      .catch((err) => console.error('Error cargando tareas para el banner:', err))
      .finally(() => setLoading(false));
  }, [projectId, user]);

  if (loading || tareas.length === 0 || !user) return null;

  const vencidas = tareas.filter(estaVencida).length;

  return (
    <div className="bg-red-500/10 border border-red-500/30 text-red-300 rounded-xl p-4 text-sm flex items-center justify-between gap-3 animate-fadeIn mb-2">
      <div className="flex items-center gap-2.5 min-w-0">
        <ClipboardList className="w-5 h-5 flex-shrink-0" />
        <span className="truncate">
          Tenés {tareas.length} tarea{tareas.length > 1 ? 's' : ''} {vencidas > 0 ? `(${vencidas} vencida${vencidas > 1 ? 's' : ''}) ` : ''}por vencer esta semana.
        </span>
      </div>
      <Link to={`/proyecto/${projectId}/tareas`} className="underline whitespace-nowrap font-medium hover:text-red-200 flex-shrink-0">
        Ver tareas
      </Link>
    </div>
  );
}
